"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonContainer = exports.dropdownContainer = void 0;

var _emotion = require("emotion");

var dropdownContainer =
/*#__PURE__*/
(0, _emotion.css)("padding:6px;");
exports.dropdownContainer = dropdownContainer;
var buttonContainer =
/*#__PURE__*/
(0, _emotion.css)("margin-bottom:10px;&:last-child{margin-bottom:0px;}");
exports.buttonContainer = buttonContainer;